<template>
  <div class="main-content" v-if="programDetail != null">
    <!-- Section: inner-header -->
    <section
      class="inner-header divider parallax layer-overlay overlay-dark-5"
      data-parallax-ratio="0.7"
      :data-bg-img="
        programDetail.program.MainImage
          ? baseUrl + programDetail.program.MainImage.url
          : ''
      "
      v-bind:style="{
        backgroundImage:
          'url(' +
          (programDetail.program.MainImage
            ? baseUrl + programDetail.program.MainImage.url
            : '') +
          ')',
      }"
    >
      <div class="container pt-180 pb-30">
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">
                {{ programDetail.program.Title }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Program Header -->
    <section id="program-header" v-if="programDetail.Description">
      <div class="container pt-40 pb-40">
        <div class="row">
          <!-- <div class="col-md-4">
            <div class="gallery-isotope grid-1 gutter clearfix">
              <div class="gallery-item">
                <div class="thumb">
                  <div class="flexslider-wrapper">
                    <div class="flexslider">
                      <ul class="slides">
                        <li
                          v-for="(img, index) in programDetail.Gallery"
                          :key="img.id"
                        >
                          <a
                            :href="baseUrl + img.url"
                            :title="'Dettaglio programma - ' + (index + 1)"
                          >
                            <img
                              :src="baseUrl + img.url"
                              :alt="img.alternativeText"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="overlay-shade"></div>
                  <div class="icons-holder">
                    <div class="icons-holder-inner">
                      <div
                        class="styled-icons icon-sm icon-dark icon-circled icon-theme-colored"
                      >
                        <a href="#">
                          <i class="fa fa-picture-o"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-md-12 description">
            <h3 class="text-uppercase mt-0 mb-10 letter-space-3">
              Dettaglio
              <span class="text-theme-colored">programma</span>
            </h3>
            <!-- <h4 class="text-theme-colored font-18 font-weight-400">
              {{ programDetail.program.Description }}
            </h4> -->
            <div class="font-16 mt-0 no-style">
              <vue-markdown
                class="markdownVideoLink"
                :source="programDetail.Description"
              ></vue-markdown>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="programDetail.Videos != null && programDetail.Videos.length > 0">
      <div class="separator pt-20"></div>

      <div class="container mt-20 mb-20 pt-20 pb-20">
        <div class="row">
          <div
            class="col-md-12"
            v-for="(vid, index) in programDetail.Videos"
            :key="vid.id"
          >
            <video
              preload="metadata"
              width="100%"
              controls
              :title="'Video - ' + (index + 1)"
            >
              <source :src="baseUrl + vid.url" :type="vid.mime" />
            </video>
          </div>
        </div>
      </div>
    </div>

    <div class="separator pt-20"></div>

    <div class="container mt-20 mb-20 pt-20 pb-20">
      <div id="accordion1" class="panel-group accordion">
        <div id="accordion1" class="panel-group accordion">
          <div
            class="panel"
            v-for="grouped in programDetail.groupedByWeek"
            :key="grouped.ID"
          >

            <program-detail-item
              :name="'firstLevel' + grouped.ID"
              v-bind:itemView="grouped"
              v-bind:userTracks="userTracks"
              v-bind:idProgramDetail="programDetail.id"
              v-bind:accordionParentName="accordionParent"
              @reload="reloadUserTrack" 
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 
    <section id="steps" data-bg-img="images/pattern/p17.png">
      <div class="container mt-20 mb-20 pt-20 pb-20" v-for="(item) in programDetail.ProgramDetailItem" :key="item.id">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-uppercase mt-0 mb-10 letter-space-3 line-bottom"><span class="text-theme-colored">{{item.Title}}</span></h3>
            <div class="font-18 mt-0 mb-30 no-style" ><vue-markdown :source="item.Description"></vue-markdown></div>
          </div>
          <div class="col-md-6" v-if="item.Gallery != null && item.Gallery.length > 0">
            <h5 class="text-uppercase mt-0 mb-10 letter-space-2">Galleria:</h5>
            <div class="gallery-isotope grid-2 gutter-small clearfix" data-lightbox="gallery">
              <div class="gallery-item" v-for="(img, index) in item.Gallery" :key="img.id">
                <a :href="baseUrl + img.url" :title="'Immagine - ' + (index + 1)" data-lightbox="gallery-item">
                  <img :src="baseUrl + img.url" :alt="img.alternativeText">
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="item.Videos != null && item.Videos.length > 0">
            <h5 class="text-uppercase mt-0 mb-10 letter-space-2">Video:</h5>
            <div class="row">
              <div class="col-md-12" v-for="(vid, index) in item.Videos" :key="vid.id">
                <video width="100%" controls :title="'Video - ' + (index + 1)">
                  <source :src="baseUrl + vid.url" :type="vid.mime">
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <video-modal
      v-bind:videoView="videoToView"
      v-on:closeModal="videoToView = null"
    />
  </div>
</template>

<style scoped>
#program-header .flexslider-wrapper .flexslider {
  max-height: 400px;
}
#program-header .container {
  min-height: 440px;
}

.panel-group .panel-title a::after {
  font-size: 20px;
}

.panel-group .panel-title a {
  font-size: 20px;
}

.sub-panel-title a {
  color: #ee163b;
}

.thirth-panel-title a {
  color: white;
}
</style>

<script>
import axios from "axios";
import VueMarkdown from "vue-markdown";
import VideoModal from "../../components/VideoModal.vue";
import ProgramDetailItem from "../auth/ProgramDetailItem.vue";

export default {
  name: "ProgramDetail",
  props: ["ID"],
  components: {
    VueMarkdown,
    VideoModal,
    ProgramDetailItem
  },
  data() {
    return {
      programDetail: null,
      userTracks: [],
      videoToView: null,
      accordionParent: 'accordion1',
      baseUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    AddListenerOpenLinkVideo() {
      window.addEventListener("click", (event) => {
        // ensure we use the link, in case the click has been received by a subelement
        let { target } = event;
        while (target && target.tagName !== "A") target = target.parentNode;
        // handle only links that do not reference external resources
        if (target && target.matches("a:not([href*='/'])") && target.href) {
          // some sanity checks taken from vue-router:
          // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
          const {
            altKey,
            ctrlKey,
            metaKey,
            shiftKey,
            button,
            defaultPrevented,
          } = event;
          // don't handle with control keys
          if (metaKey || altKey || ctrlKey || shiftKey) return;
          // don't handle when preventDefault called
          if (defaultPrevented) return;
          // don't handle right clicks
          if (button !== undefined && button !== 0) return;
          // don't handle if `target="_blank"`
          if (target && target.getAttribute) {
            const linkTarget = target.getAttribute("target");
            if (/\b_blank\b/i.test(linkTarget)) return;
          }
          // don't handle same page links/anchors
          const url = new URL(target.href);
          const to = url.pathname;
          if (window.location.pathname !== to && event.preventDefault) {
            event.preventDefault();
            let videoKey = to.replace("/", "");
            console.log(videoKey);

            axios
              .get(process.env.VUE_APP_API_URL + "/videos?KeyName=" + videoKey)
              .then((response) => {
                if (response.data.length > 0) {
                  this.videoToView = response.data[0];
                  console.log(this.videoToView);
                }
              });
          }
        }
      });
    },
    reloadUserTrack(){
      axios
      .post(process.env.VUE_APP_API_URL + "/userprogress/getbyuser", {
        IdProgram: this.ID,
      })
      .then((data) => {this.userTracks =data.data;})
    }
  },
  mounted() {
    axios
      .post(process.env.VUE_APP_API_URL + "/user/getProgramDetail", {
        IdProgram: this.ID,
      })
      .then((response) => {
        this.programDetail = response.data;

        console.log("aaa", this.programDetail.id);

        axios
      .post(process.env.VUE_APP_API_URL + "/userprogress/getbyuser", {
        IdProgram: this.ID,
      })
      .then((data) => {this.userTracks =data.data;})
        // console.log("NOT GROUPED", this.programDetail);
        // this.programDetail.groupedByWeek = response.data.ProgramDetailItem.reduce(
        //   function (res, currentValue) {
        //     if (res.indexOf(currentValue.Week) === -1) {
        //       res.push(currentValue.Week);
        //     }
        //     return res;
        //   },
        //   []
        // ).map(function (Week, index) {
        //   return {
        //     ID: index,
        //     Week: Week,
        //     Items: response.data.ProgramDetailItem.filter(function (_el) {
        //       return _el.Week === Week;
        //     }).map(function (_el) {
        //       return _el;
        //     }),
        //   };
        // });

        let groupedByWeekList = [];
        let id = 0;
        response.data.ProgramDetailItem.forEach(element => {

          id = id + 1;

          if(element.Week == "" || (element.Week != "" && element.Title == null)){
            groupedByWeekList.push({ID: id, Title: element.Week != "" ? element.Week : element.Title, Items: [], Obj: element})
          }
          else{
            let indexWeek = groupedByWeekList.findIndex(x => x.Title == element.Week);
            
            let obj = null;
            let skipAdd = false;
            if(element.Title?.includes('-')){
              let typeWorkout = element.Title.split('-')[0];
              let nWorkout = element.Title.split('-')[1];

              let listOfNWorkout = groupedByWeekList.find(x => x.Title == element.Week)?.Items?.find(x => x?.Title == nWorkout);
              let alreadyInArray = false;
              //ADD TIPO ALLENAMENTO
              if(listOfNWorkout != undefined){
                listOfNWorkout.Items.push({ID: id + 5000, PanelClass: 'thirth-panel-title', Title: typeWorkout, Items: [], Obj: element});
                alreadyInArray = true;
              }
              else{
                listOfNWorkout = {ID: id + 500, PanelClass: 'sub-panel-title', Title: nWorkout, Items: [{ID: id + 5000, PanelClass: 'thirth-panel-title', Title: typeWorkout, Items: [], Obj: element}], Obj: null};
              }

              //ALLENAMENTO
              obj = listOfNWorkout;

              if(alreadyInArray){
                skipAdd = true;
              }

            }
            else{
               obj = {ID: id+ 500, PanelClass: 'sub-panel-title', Title: element.Title, Items: [], Obj: element}
            }

            if(indexWeek >= 0){
              //ADD ALLENAMENTO TO WEEK
              if(!skipAdd){
                groupedByWeekList[indexWeek].Items.push(obj);
              }
            }
            else{
              groupedByWeekList.push({ID: id, Title: element.Week, Items: [obj], Obj: null, IdProgramDetail: this.programDetail.id})
            }
          }
        });

        this.programDetail.groupedByWeek = groupedByWeekList

        console.log("GROUPED:", this.programDetail.groupedByWeek);
      });

    this.AddListenerOpenLinkVideo();
  },
};
</script>